import { Attributes, Validation, ValueObject } from '@singularsystems/neo-core';

export default class MultiSelectDropDownConfig extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.Integer()
    public minSelectedItems: number = 0;

    @Attributes.Nullable()
    @Attributes.Integer()
    public maxSelectedItems: number | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<MultiSelectDropDownConfig>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Multi Select Drop Down Config";
    }
}